import { JSX } from 'react';
import { C09AZIndexProps } from './C09AZIndex.types';
import { GetAZIndexModel } from './C09AZIndex.service';
import { AlphaLinksIndex } from '@ahc-digital/component-library';
import { PromptForUnavailableInTheme } from 'src/shared/PromptForUnavailableInTheme';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C09AZIndexProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (context?.siteTheme?.value === 'Corporate')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value}
        componentName={props?.rendering?.componentName}
      />
    );

  const model = GetAZIndexModel(props);
  return (
    <AlphaLinksIndex
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C09AZIndexProps>(Default);
